import { STORAGE_URL } from 'services';
import { PuzzleDTO } from 'types';

export function buildPreviousVersionUrl(puzzleData: {
  type: PuzzleDTO['type'];
  url: PuzzleDTO['url'];
  uuid: string;
}) {
  if (puzzleData.type === 'static') {
    const url = new URL(puzzleData.url);
    return `${url.origin}${url.pathname}_previous${url.search}`;
  } else {
    return `${STORAGE_URL}/videoPuzzles/${puzzleData.uuid}/original_previous`;
  }
}
